// Archivo centralizado de servicios - edita aquí y se actualiza en todo el sitio

export const servicesLeft = [
  { 
    id: 'realestate-fund', 
    name: 'Fund: "AAC Real Estate I"', 
    subtitle: 'Secure thanks to creating new housing, solving Spain\'s shortage',
    badge: '+20%',
    description: 'Secure thanks to creating new housing, solving Spain\'s shortage',
    num: '01'
  },
  { 
    id: 'quant-fund', 
    name: 'Fund: "AAC Quantitative DAO"', 
    subtitle: 'Algorithmic Forex, Gold & Crypto',
    badge: '+20%',
    description: 'Algorithmic Forex, Gold & Crypto',
    num: '02'
  },
  { 
    id: 'crypto', 
    name: 'Crypto OTC & Lending', 
    subtitle: 'High Volume BTC/USDT',
    description: 'High Volume BTC/USDT',
    num: '03'
  },
  { 
    id: 'tax', 
    name: 'Tax Optimization & Structures', 
    subtitle: 'OF 0% · Spain · LLCs · Dubai',
    description: 'OF 0% · Spain · LLCs · Dubai',
    num: '04'
  },
];

export const servicesRightTop = [
  { 
    id: 'offmarket', 
    name: 'Off-Market Real Estate', 
    subtitle: 'Hotels, Villas, Marbella...', 
    description: 'Hotels, Villas, Marbella...',
    num: '05' 
  },
  { 
    id: 'gold', 
    name: 'Gold & Crypto P2P', 
    subtitle: 'Physical & Digital', 
    description: 'Physical & Digital',
    num: '06' 
  },
  { 
    id: 'supercars', 
    name: 'Dubai Supercar Exports', 
    subtitle: 'Up to 50% Less', 
    description: 'Dubai prices are up to 50% less',
    num: '07' 
  },
];

export const servicesRightBottom = [
  { 
    id: 'yachts', 
    name: 'Yachts & Superyachts', 
    subtitle: 'Sales & Charter', 
    description: 'Sales & Charter',
    num: '08' 
  },
  { 
    id: 'watches', 
    name: 'Luxury Watches', 
    subtitle: 'Crypto/Cash Sourcing', 
    description: 'Crypto/Cash Sourcing',
    num: '09' 
  },
  { 
    id: 'art', 
    name: 'Spanish Fine Art', 
    subtitle: 'Goya, Sorolla & Masters', 
    description: 'Goya, Sorolla & Masters',
    num: '10' 
  },
];

// Todos los servicios combinados para el menú (sin los fondos)
export const navServices = [
  { 
    name: 'All Services Overview',
    path: '/all-services',
    description: 'Complete portfolio of investment & premium services'
  },
  ...servicesLeft.filter(s => !s.id.includes('fund')).map(s => ({
    name: s.name,
    path: `/all-services#${s.id}`,
    description: s.description
  })),
  ...servicesRightTop.map(s => ({
    name: s.name,
    path: `/all-services#${s.id}`,
    description: s.description
  })),
  ...servicesRightBottom.map(s => ({
    name: s.name,
    path: `/all-services#${s.id}`,
    description: s.description
  })),
];
